import React from 'react';
import './payroll-timings.scss';
import PayrollTimingsFunctional from './components/payroll-timings-functional';

const PayrollTimings = () => {
	return <PayrollTimingsFunctional />;
};

export default PayrollTimings;
